import { Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Grid)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '50px',
  flexWrap: 'wrap',

  [theme.breakpoints.down('sm')]: {
    marginBottom: '20px',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});

export const HeadWrapper = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    marginBottom: '20px',
  },
});

export const Head = styled(Grid)({
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
});

export const Heading = styled(Typography)({
  marginRight: '20px',
});

export const Share = styled(Typography)({
  ...theme.typography.link,
  display: 'none',
  fontSize: '12px',

  [theme.breakpoints.down('md')]: {
    display: 'initial',
  },
});

export const Date = styled(Typography)({
  fontSize: '12px',
});
